// Fired after every consent change (ConsentSync bridges CookieYes's events to
// this) so consent-gated loaders (GTM) can re-check without a page reload.
// Reopening the consent UI is CookieYes-native: elements with the
// `cky-banner-element` class (footer "Cookie Settings") get a click handler
// from the SDK — no custom event plumbing needed.
export const CONSENT_UPDATED_EVENT = "pdz-consent-updated";
